import { Tag } from 'antd';
import { PresetColorType } from 'antd/lib/_util/colors';
import capitalize from 'components/utils/capitalize';
import React from 'react';

export type InfoTagProps = {
  text: string;
  color?: PresetColorType;
  icon?: React.ReactNode;
  style?: React.CSSProperties;
};

const InfoTag = ({ text, color, style, icon }: InfoTagProps): JSX.Element => {
  return (
    <Tag style={style} color={color} icon={icon}>
      {capitalize(text)}
    </Tag>
  );
};
export default InfoTag;
